import Tooltip from './Tooltip.component';

export { default as InfoTooltip } from './InfoTooltip.component';
export { default as OverflowTip } from './OverflowTip.component';
export * from './interfaces';
export default Tooltip;
